"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputLabel = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const util_1 = require("@app/util");
const classnames_1 = __importDefault(require("classnames"));
const tooltip_1 = require("../../tooltip");
const icon_1 = require("../../icon");
const COLORS = Object.freeze({
    DEFAULT: 'default',
    PRIMARY: 'primary',
    BRIGHT: 'bright',
    DANGER: 'danger',
    WARNING: 'warning',
    SUCCESS: 'success',
    WHITE: 'white',
    BLACK: 'black',
    GRAY: 'gray',
    GRAY_LIGHT: 'gray-light',
    DARK_BLUE: 'dark-blue',
    INHERIT: 'inherit',
});
const InputLabel = ({ label, subLabel, color, tooltip }) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { style: { display: 'flex', gap: '0.5rem', alignItems: 'center' } },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('input-label', color) }, label),
            (0, util_1.isDefined)(tooltip) && react_1.default.createElement(tooltip_1.Tooltip, { position: 'top', text: tooltip, anchor: react_1.default.createElement(icon_1.Icon, { size: 'small', ico: 'info' }) })),
        (0, util_1.isDefined)(subLabel) && react_1.default.createElement("div", { className: 'input-sublabel' }, subLabel)));
};
exports.InputLabel = InputLabel;
